import type { ReactNode } from 'react';
import { cx } from '@/core/utils';

/**
 * Line icon in the app's one style: 24×24 grid, round strokes (2px by default) in the current colour.
 * Decorative: the text next to it carries the meaning.
 */
interface Props {
  className?: string;
  /** Lighter (e.g. 1.75) for small icons next to text. */
  strokeWidth?: number;
  children: ReactNode;
}

export function Icon({ className, strokeWidth = 2, children }: Props) {
  return (
    <svg
      className={cx('size-5 shrink-0', className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {children}
    </svg>
  );
}
